module.exports = __webpack_public_path__ + "img/money_big.6258cc6c.png";